import * as React from "react"
import { SVGProps } from "react"
import { motion, SVGMotionProps  } from "framer-motion";

const LogoWhite = (props: SVGMotionProps<SVGSVGElement>) => (
  <motion.svg
    id="svg1"
    // width={815.64001}
    // height={678.77332}
    viewBox="0 0 815.64001 678.77332"
    {...props}
  >
    <defs id="defs1" />
    {/* <namedview
      id="namedview1"
      pagecolor="#ffffff"
      bordercolor="#000000"
      borderopacity={0.25}
    >
      <page
        x={0}
        y={0}
        id="page1"
        width={815.64001}
        height={678.77332}
        margin={0}
        bleed={0}
      />
    </namedview> */}
    <g id="g1">
      <motion.path
        id="path14"
        d="m 1489.27,4403.5 c 0,-24.64 -19.97,-44.61 -44.6,-44.61 -24.63,0 -44.6,19.97 -44.6,44.61 0,24.63 19.97,44.6 44.6,44.6 24.63,0 44.6,-19.97 44.6,-44.6"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path15"
        d="m 1676.56,4582.88 c -58.59,0 -106.26,47.66 -106.26,106.25 0,58.59 47.67,106.26 106.26,106.26 58.59,0 106.26,-47.67 106.26,-106.26 0,-58.59 -47.67,-106.25 -106.26,-106.25 z m 0,184.96 c -43.4,0 -78.71,-35.31 -78.71,-78.71 0,-43.4 35.31,-78.71 78.71,-78.71 43.4,0 78.71,35.31 78.71,78.71 0,43.4 -35.31,78.71 -78.71,78.71"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path16"
        d="m 5096,4040.16 c -58.59,0 -106.26,47.67 -106.26,106.26 0,58.6 47.67,106.26 106.26,106.26 58.59,0 106.25,-47.66 106.25,-106.26 0,-58.59 -47.66,-106.26 -106.25,-106.26 z m 0,184.97 c -43.4,0 -78.71,-35.31 -78.71,-78.71 0,-43.4 35.31,-78.71 78.71,-78.71 43.4,0 78.71,35.31 78.71,78.71 0,43.4 -35.31,78.71 -78.71,78.71"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path17"
        d="m 4807.18,2320.52 c 60.53,-38.73 93.16,-79.93 93.16,-122.68 0,-225.84 -911.27,-408.92 -2035.39,-408.92 -1124.12,0 -2035.395,183.08 -2035.395,408.92 0,21.66 8.375,42.91 24.511,63.66 l -35.562,-42.13 c -16.137,-20.74 -24.512,-42 -24.512,-63.65 0,-225.84 999.978,-430.9 2124.098,-430.9 1124.12,0 2063.55,183.09 2063.55,408.93 0,0 18.74,143.91 -170.77,209.55 l -3.69,-22.78"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path18"
        d="m 4679.81,1878.48 c 0,0 -675.35,-364.64 -2723.43,-248.97 0,0 -34.13,-10.27 78.93,-29.22 0,0 1241,-224.18 2489.35,111.56 0,0 214.24,58.72 155.15,166.63"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path19"
        d="M 869.32,2080.86 C 869.32,912.938 1772.6,27.1523 2886.86,27.1523 c 1114.25,0 2017.53,946.7887 2017.53,2114.7177 1.3,9.57 -151.21,-136.9 -151.21,-136.9 C 4753.18,900.137 3922.16,88.957 2868.1,88.957 1814.04,88.957 959.551,923.598 959.551,2028.44 l -90.231,52.42"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path20"
        d="m 4611.13,1771.25 c 0,0 -4.69,-844.012 -858.08,-1355.109 0,0 -126.6,-75.02 32.82,84.402 0,0 623.93,475.027 520.77,1192.437 l 88.79,40.76 215.7,37.51"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path21"
        d="m 3102.52,2444.89 c 0,0 189.12,-10.94 317.29,167.24 0,0 200.06,320.42 426.69,337.61 0,0 118.79,17.19 248.52,-67.21 0,0 65.64,-43.76 100.03,-39.07 0,0 201.63,-6.26 209.44,-218.82 0,0 -31.26,-21.88 -26.57,-101.6 0,0 14.07,-195.37 -439.2,-32.82 0,0 -118.79,50.02 -506.41,-90.65 0,0 -246.95,-68.77 -398.56,20.32 0,0 1.57,-20.32 29.7,-37.51 0,0 243.82,-129.73 606.44,3.12 0,0 215.69,60.96 401.68,7.82 0,0 348.55,-103.16 337.61,135.98 0,0 3.12,65.64 15.63,87.52 0,0 54.71,218.82 -236.01,265.71 0,0 -59.39,12.51 -170.37,82.84 0,0 -314.16,195.37 -642.38,-351.67 0,0 -90.66,-131.29 -240.7,-156.3 0,0 -64.08,-3.13 -32.83,-12.51"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path22"
        d="m 3526.09,3037.27 c 0,0 -139.1,-103.16 -134.41,-311.04 0,0 7.81,-103.16 -14.07,-148.48 l -137.54,-98.47 c 0,0 84.4,68.77 112.53,248.52 0,0 17.19,246.95 193.81,343.85 0,0 9.38,-4.69 -20.32,-34.38"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path23"
        d="m 3104.09,2505.85 c 0,0 78.15,0 117.22,62.52 0,0 81.28,100.03 109.41,304.78 0,0 43.76,262.58 382.93,354.8 0,0 193.81,53.14 250.08,-51.58 0,0 14.07,-6.25 1.56,25.01 0,0 142.23,46.89 114.1,-234.45 0,0 10.94,-25 20.32,7.82 0,0 71.9,254.77 -112.53,261.02 0,0 -29.7,0 -51.59,31.26 0,0 -162.54,184.43 -562.67,-179.75 0,0 -110.97,-96.9 -137.54,-359.48 0,0 -12.5,-134.42 -107.85,-204.76 0,0 -39.07,-14.06 -23.44,-17.19"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path24"
        d="m 4180.98,2765.31 c 0,0 -25,-32.83 -245.39,62.52 0,0 -182.86,92.21 -382.93,-150.05 0,0 -87.52,-129.73 -228.19,-148.48 l 57.83,57.83 c 0,0 56.27,-3.13 145.36,92.21 0,0 201.62,276.65 440.76,160.99 0,0 117.22,-64.08 182.87,-68.77 0,0 39.07,1.56 29.69,-6.25"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path25"
        d="m 2972.8,2499.6 c 0,0 39.07,-7.81 28.13,-50.01 0,0 -200.06,15.62 -206.32,176.61 0,0 -10.93,70.34 50.02,186 0,0 40.64,26.57 10.94,270.39 0,0 -59.39,434.51 226.64,501.72 0,0 59.39,15.63 96.9,75.03 0,0 90.65,110.97 254.77,84.39 0,0 287.58,-21.87 332.91,-337.6 0,0 6.26,-53.14 39.08,-60.95 0,0 -48.46,-20.32 -75.03,68.77 0,0 -48.45,256.33 -318.84,278.21 0,0 -128.17,14.07 -196.94,-85.96 0,0 -35.95,-56.27 -109.41,-67.22 0,0 -237.58,-62.52 -201.63,-451.7 0,0 64.09,-284.46 -20.32,-412.63 0,0 -93.77,-131.29 89.1,-175.05"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path26"
        d="m 3133.79,3492.1 c 0,0 -223.51,-89.1 -165.68,-540.8 0,0 23.44,-143.79 -50.02,-292.28 0,0 -18.75,-43.76 1.56,-59.39 0,0 -9.37,15.63 17.2,59.39 0,0 98.47,131.3 64.08,346.99 0,0 -42.2,298.53 151.61,464.2 0,0 23.44,39.08 -18.75,21.89"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path27"
        d="m 2983.73,2398 c 0,0 -154.73,-292.27 262.59,-264.14 0,0 60.95,9.38 142.23,-60.95 0,0 128.16,-135.98 395.43,-123.48 0,0 40.65,-32.82 71.9,10.94 0,0 237.58,-14.07 250.08,329.79 0,0 14.07,128.16 39.08,0 0,0 56.26,-353.23 -312.6,-403.25 0,0 -301.66,-42.2 -550.17,148.48 0,0 -46.89,37.52 -148.48,45.33 0,0 -173.5,10.94 -201.63,146.92 0,0 -21.88,87.53 28.13,162.55 0,0 26.57,32.82 23.44,7.81"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path28"
        d="m 3091.58,2196.38 c 0,0 37.51,-28.13 162.55,-25.01 0,0 79.71,21.88 270.4,-114.1 0,0 250.08,-135.98 431.38,-12.5 0,0 93.78,39.07 84.41,123.48 0,0 -6.26,10.94 -15.64,-15.63 0,0 -160.98,-214.13 -490.77,-51.58 0,0 -151.61,107.84 -304.78,90.65 0,0 -68.77,-6.25 -120.36,6.26 0,0 -37.5,15.62 -17.19,-1.57"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path29"
        d="m 2561.73,1982.25 c 0,0 70.34,39.07 196.93,-50.02 0,0 182.88,-151.6 537.68,-154.73 l -120.36,-21.88 -175.05,15.63 c 0,0 -170.37,48.45 -287.59,150.04 0,0 -46.89,57.84 -143.79,51.59 0,0 -25.01,6.25 -7.82,9.37"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path30"
        d="m 2449.2,1979.13 c 0,0 159.42,-176.62 328.22,-225.08 l -223.51,18.76 c 0,0 -90.65,93.78 -131.28,192.25 0,0 -9.38,32.82 26.57,14.07"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path31"
        d="m 3490.14,1890.04 c 0,0 -82.84,-101.6 -206.31,-118.79 l 137.55,-15.63 c 0,0 65.64,67.21 84.39,107.84 0,0 7.82,45.33 -15.63,26.58"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path32"
        d="m 4160.66,3009.13 c 0,0 207.88,79.71 303.23,-143.79 0,0 32.82,-51.58 68.77,-64.08 0,0 42.2,-18.76 62.52,-85.97 0,0 54.7,-98.47 131.28,-121.91 0,0 126.61,-43.77 76.59,-206.32 0,0 -45.32,-156.29 -631.44,-262.58 0,0 -42.2,-21.88 -1.57,-39.07 0,0 400.13,37.51 609.57,150.04 0,0 326.66,192.25 -53.15,468.9 0,0 -112.53,54.7 -211,223.51 0,0 -78.14,211 -361.05,134.41 0,0 -26.57,-42.2 6.25,-53.14"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path33"
        d="m 4759.29,2424.58 c 0,0 -171.93,-209.44 -628.32,-234.45 l -12.51,-39.08 c 0,0 429.83,29.7 642.39,253.21 0,0 28.13,45.33 -1.56,20.32"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path34"
        d="m 4337.29,2122.92 c 0,0 189.12,-70.33 217.25,-189.12 l 73.46,32.82 c 0,0 -75.02,140.67 -257.89,165.68 l -32.82,-9.38"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path35"
        d="m 4621.75,2201.07 c 0,0 159.42,-21.88 171.93,-159.43 l 43.76,18.76 c 0,0 -35.95,128.17 -176.62,153.17 l -39.07,-12.5"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path36"
        d="m 2882.14,2321.42 c 0,0 -29.69,-14.07 -29.69,-40.64 0,0 -64.09,-254.76 -472.02,-165.67 0,0 -39.08,34.38 -198.5,-12.51 0,0 -160.99,-32.82 -171.93,51.58 0,0 20.32,35.95 -6.26,51.58 0,0 -35.94,215.69 140.67,356.36 0,0 150.05,56.27 153.18,201.63 0,0 14.06,259.45 242.26,295.4 0,0 37.51,-29.7 90.65,7.81 0,0 71.9,35.95 196.94,-96.9 0,0 35.95,-21.88 1.56,32.82 0,0 -43.76,109.41 -217.25,114.1 0,0 -279.78,31.26 -362.62,-350.11 0,0 -50.01,-117.23 -140.67,-193.81 0,0 -164.11,-151.61 -137.54,-386.06 0,0 -53.14,-184.43 279.78,-143.79 0,0 118.78,17.19 221.94,-17.19 0,0 126.6,-20.32 261.02,46.89 0,0 167.24,67.2 157.86,232.88 l -9.38,15.63"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path37"
        d="m 2046.76,2179.83 c 0,0 90.65,-71.9 218.82,-4.69 0,0 17.19,32.82 46.89,32.82 0,0 21.88,20.32 126.6,-9.37 0,0 59.39,-34.39 117.23,15.62 0,0 6.25,34.39 89.09,23.45 0,0 125.04,9.38 189.12,168.8 0,0 18.75,37.51 15.63,-20.32 0,0 -15.63,-143.79 -182.87,-217.25 0,0 -87.53,-87.53 -245.39,-3.13 0,0 -51.58,50.02 -159.43,-20.32 0,0 -81.27,-54.7 -211,15.63 0,0 -29.7,23.45 -4.69,18.76"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path38"
        d="m 2335.1,2001.01 c 0,0 -43.77,10.94 -73.46,-17.2 0,0 -181.31,-150.04 -295.41,-175.05 l 145.36,-9.38 c 0,0 159.43,103.16 212.57,170.37 0,0 21.88,21.88 10.94,31.26"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path39"
        d="m 2130.35,1976 c 0,0 -184.44,-131.29 -371.99,-151.61 l -118.79,34.38 c 0,0 231.32,0 468.89,117.23 0,0 37.52,23.45 21.89,0"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path40"
        d="m 1608.31,2136.99 c 0,0 32.82,-21.88 -18.76,-42.2 0,0 6.25,-37.52 -76.59,-73.47 0,0 -178.17,-64.08 -187.55,-115.66 l -114.1,28.14 c 0,0 85.96,53.14 142.23,64.08 0,0 -32.82,9.38 -75.02,43.76 0,0 -34.39,26.57 -109.41,21.89 0,0 -259.458,20.31 -265.708,192.24 0,0 -56.269,140.67 23.446,201.63 0,0 20.316,23.44 35.949,57.83 0,0 167.243,190.68 342.293,204.75 0,0 48.45,-4.69 -9.38,-25.01 0,0 -18.75,-21.88 -82.83,-43.76 0,0 -121.92,-53.14 -173.5,-134.42 0,0 -142.232,-134.41 -101.595,-264.14 0,0 21.883,-146.92 245.395,-148.49 0,0 10.94,-6.25 35.95,-3.12 0,0 39.07,12.5 65.64,-17.2 0,0 101.59,-67.2 298.53,42.21 0,0 18.75,17.19 25.01,10.94"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path41"
        d="m 2210.06,2748.11 c 0,0 -135.98,-110.97 -451.7,85.97 0,0 -29.7,42.2 -82.84,34.38 0,0 -162.56,104.72 -257.89,25.01 0,0 -35.95,-92.21 -14.07,-112.53 0,0 87.53,-82.84 93.78,-186 0,0 -35.95,-350.11 422,-472.02 0,0 39.08,-7.81 -14.06,-20.32 0,0 -225.07,-14.06 -384.5,165.68 0,0 -118.79,126.6 -90.65,320.41 0,0 15.63,62.52 -53.15,162.55 0,0 -42.19,89.09 7.82,145.36 0,0 10.94,17.19 10.94,32.82 0,0 182.87,103.16 365.74,-28.13 0,0 289.15,-190.69 442.32,-112.54 0,0 46.9,23.45 4.7,-20.32 0,0 17.19,-10.94 1.56,-20.32"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path42"
        d="m 1442.63,2870.03 c 0,0 -53.14,-23.45 59.39,-170.37 0,0 42.21,-48.45 46.89,-170.36 0,0 12.51,-234.45 373.56,-356.37 0,0 -18.76,25.02 1.56,43.77 0,0 4.69,70.34 14.07,96.91 0,0 7.81,31.25 -25.01,9.37 0,0 -93.78,-53.14 -193.81,26.57 0,0 -43.76,-17.19 -48.45,43.77 0,0 -57.83,51.57 -92.22,253.2 0,0 -6.25,76.59 -45.32,68.77 0,0 -89.09,73.46 -90.66,154.74"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path43"
        d="m 2824.31,3221.7 c 0,0 -4.69,-26.57 -43.76,-14.07 0,0 -251.64,248.52 -673.65,109.41 0,0 -43.76,-20.32 -37.51,-87.52 0,0 6.25,-59.4 -70.34,-98.47 0,0 -148.48,-79.72 -50.01,-254.77 0,0 10.94,-29.7 -29.7,6.25 0,0 -101.59,162.55 57.83,295.4 0,0 48.46,26.58 39.08,109.41 0,0 6.25,109.41 85.96,126.61 0,0 43.77,-4.69 64.09,14.06 0,0 225.07,45.33 437.63,-34.38 0,0 62.52,10.94 71.9,-46.89 0,0 129.72,-68.78 148.48,-125.04"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path44"
        d="m 1934.97,3210.76 c 0,0 -32.82,-25.01 -76.58,-15.63 0,0 -200.07,123.48 -453.27,25.01 0,0 -26.57,26.57 -53.14,-12.51 0,0 -162.55,-89.09 -181.31,-226.63 0,0 -60.96,-193.81 -28.13,-286.03 0,0 -6.25,-14.06 -21.88,1.57 0,0 -45.33,245.39 79.71,420.44 0,0 78.15,190.68 185.99,206.31 0,0 234.45,78.15 417.32,-42.2 0,0 23.45,1.57 29.7,-17.19 0,0 106.28,-31.26 101.59,-53.14"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path45"
        d="m 2908.71,3410.82 c 0,0 -123.47,146.92 -331.35,181.31 0,0 15.63,6.25 65.64,-1.57 0,0 181.31,-28.13 289.16,-126.6 l -23.45,-53.14"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path46"
        d="m 2957.17,3504.6 c 0,0 -117.23,117.22 -320.42,123.47 0,0 -145.36,-4.68 -253.2,28.14 0,0 -96.91,42.2 -128.16,-106.28 0,0 -21.89,-78.15 -51.59,-71.9 0,0 -60.95,29.7 26.58,178.18 0,0 50.01,75.02 107.84,73.46 0,0 245.39,43.76 509.54,-84.4 0,0 31.26,-10.94 29.69,-34.39 0,0 112.54,-35.95 139.11,-76.58 l -59.39,-29.7"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path47"
        d="m 1142.54,3126.36 c 0,0 -119.57,-182.87 -96.13,-475.93 0,0 -11.72,-44.55 -35.16,-21.1 0,0 -14.062,264.92 112.54,475.93 l 18.75,21.1"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path48"
        d="m 3705.05,3684.34 c 0,0 -321.19,241.48 -555.64,9.38 0,0 -93.78,-121.91 -189.9,-58.61 0,0 67.99,-37.51 145.36,72.68 0,0 208.66,248.51 569.71,9.38 l 30.47,-32.83"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path49"
        d="m 4973.42,2331.58 c 0,0 100.81,248.51 -229.76,414.97 0,0 -157.08,79.71 -211,232.11 0,0 93.77,-161.77 243.82,-211.01 0,0 403.25,-143.01 222.73,-480.61 0,0 -11.73,2.34 -25.79,44.54"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path50"
        d="m 3119.71,2448.02 c 0,0 123.48,-98.47 372,1.57 0,0 318.84,139.1 497.03,51.57 0,0 178.18,-73.46 270.39,-40.64 0,0 -146.92,-12.5 -268.83,65.65 0,0 -182.87,104.72 -437.64,0 0,0 -142.23,-118.79 -251.64,-18.76 l -139.1,-50.01 -42.21,-9.38"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path51"
        d="m 4310.71,2077.59 c 0,0 54.71,-3.12 73.46,-53.14 0,0 -14.06,-32.82 39.08,-32.82 0,0 62.52,-12.5 71.89,-67.21 l -365.73,-70.33 c 0,0 218.81,76.58 181.3,171.93 0,0 -34.38,57.82 0,51.57"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path52"
        d="m 2339.79,1941.61 c 0,0 -67.21,-101.59 -181.31,-143.79 l 179.74,-14.07 c 0,0 42.21,45.33 6.26,82.84 0,0 23.44,109.41 -4.69,75.02"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path53"
        d="m 1311.34,1971.31 c -4.69,0 -70.33,82.84 -236.01,67.21 0,0 -25.01,-7.82 15.63,-15.63 0,0 110.97,-4.69 115.66,-90.66 l 87.53,-10.94 17.19,50.02"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path54"
        d="m 1321.93,2205.35 c -5.52,0.99 -11.16,-1.76 -12.8,-7.38 -1.4,-4.77 0.62,-10.92 5.37,-13.02 0.26,-0.12 0.52,-0.2 0.79,-0.29 1.76,-2.02 4.61,-3.27 7.16,-2.26 5,1.99 8.91,6.28 8.74,11.99 -0.15,5.26 -3.99,10.02 -9.26,10.96"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path55"
        d="m 2269.04,2992.21 c -5.32,4.57 -13.21,4.69 -18.01,-0.7 -5.08,-5.72 -4.4,-13.68 1.73,-18.19 0.17,-0.12 0.36,-0.19 0.54,-0.3 -0.41,-2.79 0.68,-5.98 3.33,-7.2 7.42,-3.43 14.85,0.67 17.44,8.21 2.15,6.28 0,13.85 -5.03,18.18"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path56"
        d="m 2588.6,2913.11 c -14.68,3.65 -24.09,-13.66 -21,-26.11 1.85,-7.46 11.91,-5.87 13.54,0.18 1.78,0.76 3.52,1.61 5.2,2.56 3.28,1.88 7.22,4.2 9.23,7.5 3.98,6.53 0.23,14.08 -6.97,15.87"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path57"
        d="m 2591.51,2663.96 c -3.53,3.8 -8.57,6.24 -13.82,5.75 -5.55,-0.51 -10.44,-4.32 -12.05,-9.72 -3.37,-11.3 10.82,-19.92 19.33,-11.93 1.27,1.19 1.92,2.52 2.1,3.85 4.9,0.7 8.91,7.24 4.44,12.05"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path58"
        d="m 1553.15,3110.18 c -18.02,-3.88 -29.62,-23 -22.72,-40.55 0.21,-0.55 0.47,-1.04 0.75,-1.48 -0.06,-1.99 0.02,-4.01 0.42,-6.08 1.7,-8.88 15.26,-5.12 13.56,3.74 -3.48,18.21 24.99,15.37 34.76,13.71 3.6,-0.61 7.76,0.91 8.65,4.91 4.43,19.82 -19.36,29.2 -35.42,25.75"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path59"
        d="m 2439.66,3227.79 c -6.32,7.13 -15.75,9.29 -24.87,9.93 -15.87,1.1 -33.07,1.58 -48.93,0.46 -7.43,-0.53 -14.48,-2.59 -17.71,-10.01 -4.51,-10.38 3.07,-20.45 5.33,-30.21 0.38,-1.6 1.14,-2.78 2.11,-3.6 -0.25,-7.56 0.47,-15.24 0.74,-21.12 0.4,-9.01 14.47,-9.06 14.06,0 -0.34,7.67 -0.5,15.34 0.06,22.99 0.58,8 2.74,11.54 11.4,13.59 2.86,0.68 6.52,0.58 9.45,0.56 10.35,-0.07 15.92,-3.86 24.19,-9.51 3.59,-2.45 6.63,-4.76 11.11,-5.27 18.11,-2.09 23.29,20.65 13.06,32.19"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path60"
        d="m 1705.71,2722.47 c -11.03,6.85 -23.21,9.84 -35.07,3.34 -0.75,-0.41 -1.32,-0.9 -1.8,-1.42 -3.52,-0.66 -7.04,-1.74 -10.42,-3.02 -8.38,-3.17 -4.75,-16.78 3.74,-13.57 2.76,1.05 5.62,2.28 8.54,2.81 6.99,1.26 8.57,-0.22 13.23,-5.72 3.59,-4.24 5.98,-7.5 11.12,-9.96 8.25,-3.95 22.11,-6.8 26.13,4.24 3.93,10.82 -7.87,18.58 -15.47,23.3"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path61"
        d="m 1297.18,2451.82 c -9.11,1.44 -20.95,1.16 -29.58,-2.65 -10.33,-4.57 -6.11,-13.16 -10.87,-20.96 -1.86,-3.05 -1.08,-5.99 0.82,-7.97 -2.26,-6.27 -2.6,-13.44 -0.1,-20.88 2.87,-8.54 16.46,-4.88 13.57,3.74 -3.41,10.13 2.12,24.04 14.11,25.04 5.76,0.49 11.68,-2.53 15.37,-6.85 4,-4.68 3.39,-9.4 4.66,-14.89 1.43,-6.15 5.67,-13.12 13.25,-10.86 7.84,2.34 11.39,12.76 11.72,19.99 0.87,19.35 -14.93,33.43 -32.95,36.29"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path62"
        d="m 3121.26,2877.61 c -3.81,-0.95 -7.63,-1.84 -11.45,-2.77 -1.31,1.62 -3.38,2.59 -5.63,2.89 -2.63,0.35 -5.26,0.7 -7.89,1.06 -0.28,0.7 -0.58,1.41 -0.91,2.14 -1.53,3.39 -2.13,6.82 -1.09,10.32 4.04,1.27 8.39,1.46 12.67,1.19 9.04,-0.59 9,13.48 0,14.06 -6.3,0.41 -12.8,-0.61 -18.69,-2.89 -1.81,0.12 -3.6,-0.54 -4.87,-2.31 -10.46,-5.72 -17.9,-15.85 -16.59,-29.37 0.9,-9.26 6.8,-17.17 16.71,-17.06 13.4,0.15 28.55,5.92 41.48,9.18 8.77,2.21 5.05,15.78 -3.74,13.56"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path63"
        d="m 3235.18,3461.31 c -1.98,3.38 -6.27,4.33 -9.63,2.52 -5.04,-2.71 -8.19,-8.21 -8.04,-13.93 0.09,-3.67 3.17,-7.2 7.03,-7.03 3.73,0.17 7.14,3.09 7.03,7.03 0,0.34 -0.02,0.48 -0.03,0.53 0.02,0.13 0.01,0.19 0,0.22 0.05,0.09 0.1,0.17 0.18,0.31 0.05,0.08 0.1,0.15 0.15,0.22 v 0 c 0,0 0,0 0,0.01 0.03,0.04 0.06,0.08 0.08,0.11 0.09,0.11 0.15,0.2 0.18,0.24 -0.02,-0.07 0.04,-0.12 0.52,0.14 3.35,1.8 4.4,6.43 2.53,9.63"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path64"
        d="m 3231.87,3451.18 c 0.29,0.36 0.22,0.3 0.08,0.12 -0.04,-0.05 -0.02,-0.04 -0.08,-0.11 v -0.01"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path65"
        d="m 3476,2919.09 c -0.03,0 -0.05,0 -0.09,0.01 -0.22,0.18 -0.44,0.36 -0.68,0.51 -3.35,1.95 -7.64,0.73 -9.63,-2.52 -2.68,-4.41 -0.47,-9.72 4.03,-11.72 4.87,-2.17 9.39,0.35 11.28,5.07 1.38,3.42 -1.49,7.87 -4.91,8.65"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path66"
        d="m 3797.85,3124.64 c -2.93,2.86 -7.28,4.36 -10.94,2.73 -2.41,0.68 -5.17,0.2 -6.9,-1.72 -5.57,-6.17 -4.94,-16.52 2.74,-20.77 7.09,-3.92 17.07,0.14 18.6,8.28 0.76,4.09 -0.48,8.55 -3.5,11.48"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path67"
        d="m 3790.21,3116.02 c -0.01,-0.02 -0.03,-0.03 -0.04,-0.05 0.02,0.02 0.02,0.01 0.04,0.03 0,0.02 0,0 0,0.02"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path68"
        d="m 2186.85,2377.59 c -2.34,6.61 -8.67,11.32 -15.78,11.03 -3.93,-0.16 -6.16,-2.92 -6.67,-5.96 -3.05,0.32 -6.26,-1.11 -7.37,-4.9 -4.03,-13.74 11.67,-26.06 23.7,-17.52 5.43,3.85 8.41,10.87 6.12,17.35 z m -13.97,-5.74 c -1.99,-1.59 -2.61,1.08 -2.29,2.17 0.06,0.19 0.07,0.37 0.11,0.55 0.12,0 0.23,-0.03 0.37,-0.02 1.67,0.07 3.47,-1.37 1.81,-2.7"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path69"
        d="m 1963.75,2628.92 c -4.24,5.3 -11.52,6.38 -17.83,7.11 -7.79,0.9 -17.56,2.01 -24.54,-2.35 -12.86,-8.03 -16.97,-27.97 -15.16,-41.82 0.16,-1.15 0.53,-2.15 1.06,-3 0.19,-2.66 0.66,-5.33 1.47,-7.98 2.62,-8.64 16.2,-4.95 13.56,3.74 -2.57,8.43 -0.75,17.76 6.56,23.28 7.77,5.86 14.73,3.6 23.15,1.35 11.73,-3.14 18.84,10.79 11.73,19.67"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path70"
        d="m 3876.31,2255.85 c -1.75,2.12 -4.06,3.91 -6.68,5.35 -0.75,0.76 -1.7,1.4 -2.92,1.8 -13.51,4.41 -29.8,2.88 -39.97,-7.96 -8.87,-9.46 -10.93,-25.06 -3.5,-35.95 0.17,-0.25 0.36,-0.46 0.54,-0.7 -0.05,-2.15 -0.03,-4.29 0.06,-6.37 0.2,-5.34 5.2,-7.51 9.18,-6.54 0.3,-0.13 0.61,-0.26 0.94,-0.34 3.85,-0.87 7.43,1.16 8.65,4.91 0.51,1.57 1.02,3.14 1.52,4.71 0.41,1.26 0.34,2.63 -0.07,3.91 1.2,1.81 2.21,3.88 2.78,6.33 1.29,5.49 0.35,11.06 0.4,16.6 3.44,1.85 7.5,2.02 10.57,-0.85 2.27,-2.14 3.19,-5.25 5.86,-7.07 4.92,-3.34 11.18,-1.23 14.36,3.42 3.88,5.69 2.45,13.68 -1.72,18.75"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path71"
        d="m 3765.61,2121.5 c -2.36,2.36 -5.52,2.46 -8.2,1.11 -2.68,1.33 -5.86,1.22 -8.19,-1.11 -2.49,-2.49 -2.94,-7.52 0,-9.95 1.07,-0.89 2.15,-1.78 3.23,-2.67 3.14,-2.59 6.78,-2.62 9.94,0 1.07,0.89 2.15,1.78 3.22,2.67 2.93,2.43 2.51,7.44 0,9.95"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path72"
        d="m 2856.48,2016.85 c -1.87,2.92 -5.52,4.22 -8.71,2.94 -1.2,2.29 -3.6,4 -6.23,3.88 -3.86,-0.18 -6.96,-3.1 -7.03,-7.04 -0.12,-6.9 3.85,-15.48 11.85,-15.53 7.75,-0.05 14.78,8.47 10.12,15.75"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path73"
        d="m 3075.95,1895.5 c -9.05,0 -9.06,-14.06 0,-14.06 9.05,0 9.07,14.06 0,14.06"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path74"
        d="m 1763.72,2005.19 c -0.17,3.83 -3.09,7.01 -7.03,7.03 -4.83,0.03 -9.55,-2.27 -11.87,-6.62 -2.29,-4.3 -1.25,-9.82 2.28,-13.13 3.96,-3.72 9.92,-3.47 13.68,0.36 2.4,2.44 3.29,6.3 2.39,9.59 0.39,0.86 0.6,1.79 0.55,2.77"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path75"
        d="m 1727.09,1917.39 c -9.05,0 -9.06,-14.07 0,-14.07 9.06,0 9.07,14.07 0,14.07"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path76"
        d="m 3491.73,3502.06 c -9.85,9.22 -26.09,10.32 -37.01,2.63 -8.59,-6.05 -12.52,-15.11 -14.25,-24.85 -3.39,-6.12 -4.01,-13.26 -1.64,-19.96 -0.39,-2.25 -0.68,-4.5 -0.86,-6.68 -0.73,-9.02 13.34,-8.98 14.07,0 0.1,1.21 0.23,2.47 0.38,3.74 0.54,0.94 0.92,1.99 0.9,3.22 -0.01,0.65 -0.02,1.32 -0.03,2 1.85,8.44 6.1,15.44 16.75,11.69 6.92,-2.44 13.64,-5.37 20.89,-2 12.75,5.93 9.34,22.22 0.8,30.21"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path77"
        d="m 4641.65,2463.14 c -4.88,9.68 -19.9,16.96 -30.36,16.66 -11.58,-0.33 -22.47,-10.33 -21.22,-22.28 0.15,-1.45 0.67,-2.64 1.4,-3.63 -0.26,-2.48 -0.22,-5.05 0.29,-7.64 1.71,-8.88 15.27,-5.12 13.56,3.74 -1.23,6.35 3.97,12.57 10.56,11.23 6.29,-1.27 6.4,-6.92 10.26,-10.75 8.72,-8.63 20.52,2.75 15.51,12.67"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path78"
        d="m 4434.19,2376.91 c -9.05,0 -9.07,-14.07 0,-14.07 9.05,0 9.06,14.07 0,14.07"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path79"
        d="m 2627.38,2722.32 c -9.06,0 -9.07,-14.06 0,-14.06 9.05,0 9.06,14.06 0,14.06"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path80"
        d="m 3676.14,2281.56 c -9.05,0 -9.07,-14.06 0,-14.06 9.05,0 9.07,14.06 0,14.06"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path81"
        d="m 4056.86,2656.68 c -1.43,4.83 -5.38,7.73 -10.29,8.15 -2.05,0.18 -4.04,-0.95 -5.38,-2.58 -2.38,-0.57 -4.21,-2.37 -5.23,-4.91 -4.1,-10.26 10.23,-19.35 18.08,-12.04 3.07,2.86 3.99,7.43 2.82,11.38"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path82"
        d="m 3776.17,2645.74 c -9.05,0 -9.06,-14.07 0,-14.07 9.05,0 9.07,14.07 0,14.07"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path83"
        d="m 3224.44,3166.21 c -9.05,0 -9.07,-14.07 0,-14.07 9.05,0 9.06,14.07 0,14.07"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path84"
        d="m 3035.27,2042.81 c -2.67,-0.18 -5.26,-1.74 -6.41,-4.1 -2.57,-0.46 -4.62,-2.29 -5.59,-4.99 -4.35,-12.17 12.69,-23.17 21.98,-14.19 8.17,7.89 1.65,24.07 -9.98,23.28"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path85"
        d="m 1878.7,2478.5 c -9.05,0 -9.06,-14.07 0,-14.07 9.06,0 9.07,14.07 0,14.07"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path86"
        d="m 4252.87,1959.4 c -1.57,0.36 -3.11,0.21 -4.48,-0.34 -1.36,1.34 -3.21,2.19 -5,2.11 -4.11,-0.18 -6.66,-3.1 -7.03,-7.03 -0.52,-5.42 3.82,-10.71 9.15,-11.42 5.63,-0.76 10.62,2.64 12.27,8.03 1.08,3.52 -1.28,7.83 -4.91,8.65"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path87"
        d="m 1363.91,3001.44 c -9.05,0 -9.07,-14.06 0,-14.06 9.05,0 9.06,14.06 0,14.06"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path88"
        d="m 2096.04,2956.2 c -9.05,0 -9.06,-14.07 0,-14.07 9.05,0 9.07,14.07 0,14.07"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path89"
        d="m 2513.35,3510.9 c -3.34,0.59 -7.1,-0.77 -8.36,-4.08 -3.13,-1.3 -5.27,-5 -4.17,-8.36 2.39,-7.3 12.04,-10.65 17.72,-4.69 5.12,5.35 2.44,15.78 -5.19,17.13"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path90"
        d="m 992.492,2396.44 c 0,0 -101.594,-253.2 171.928,-259.45 0,0 20.32,31.26 51.58,7.81 0,0 67.21,6.25 95.34,-31.26 0,0 118.79,-62.52 268.84,42.2 0,0 -18.76,7.82 -31.27,3.13 0,0 -150.04,-79.71 -243.82,-18.76 0,0 -39.07,53.14 -157.86,45.33 0,0 -37.52,-32.82 -106.28,10.94 0,0 -71.903,20.32 -50.02,170.37 l 1.562,29.69"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path91"
        d="m 1236.32,3054.46 c 0,0 -92.22,-115.66 -54.71,-392.31 l 48.46,23.44 c 0,0 -64.09,164.12 1.56,346.99 0,0 17.19,34.38 4.69,21.88"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path137"
        d="m 5305.91,2050.35 c 0,0 47.91,66.2 198.6,-49.65 0,0 45.29,-21.77 136.75,-6.09 0,0 78.39,34.84 187.28,-93.2 0,0 120.2,-136.76 203.82,-144.6 0,0 3.48,3.49 -14.81,7.84 0,0 -103.66,47.04 -198.6,163.76 0,0 -61.84,101.91 -197.72,79.26 0,0 -79.27,-14.81 -122.82,12.2 0,0 -131.53,103.65 -196.86,34.84 0,0 -10.44,-10.46 4.36,-4.36"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path140"
        d="m 1882.7,3827.46 c 0,-29.35 -23.8,-53.14 -53.15,-53.14 -29.35,0 -53.14,23.79 -53.14,53.14 0,29.34 23.79,53.14 53.14,53.14 29.35,0 53.15,-23.8 53.15,-53.14"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path141"
        d="m 1935.84,3711.8 c 0,-13.82 -11.2,-25.01 -25.01,-25.01 -13.81,0 -25.01,11.19 -25.01,25.01 0,13.81 11.2,25 25.01,25 13.81,0 25.01,-11.19 25.01,-25"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path142"
        d="m 2041.33,3767.28 c -69.81,0 -126.6,56.8 -126.6,126.6 0,69.81 56.79,126.6 126.6,126.6 69.81,0 126.6,-56.79 126.6,-126.6 0,-69.8 -56.79,-126.6 -126.6,-126.6 z m 0,220.38 c -51.71,0 -93.78,-42.07 -93.78,-93.78 0,-51.7 42.07,-93.77 93.78,-93.77 51.71,0 93.78,42.07 93.78,93.77 0,51.71 -42.07,93.78 -93.78,93.78"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path143"
        d="m 5071.64,1275.32 c 0,-29.35 -23.8,-53.14 -53.15,-53.14 -29.35,0 -53.14,23.79 -53.14,53.14 0,29.35 23.79,53.14 53.14,53.14 29.35,0 53.15,-23.79 53.15,-53.14"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path144"
        d="m 5174.79,1311.27 c 0,-14.67 -11.9,-26.57 -26.57,-26.57 -14.67,0 -26.57,11.9 -26.57,26.57 0,14.68 11.9,26.57 26.57,26.57 14.67,0 26.57,-11.89 26.57,-26.57"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path145"
        d="m 5189.63,965.07 c -69.81,0 -126.6,56.8 -126.6,126.6 0,69.81 56.79,126.6 126.6,126.6 69.81,0 126.6,-56.79 126.6,-126.6 0,-69.8 -56.79,-126.6 -126.6,-126.6 z m 0,220.38 c -51.7,0 -93.77,-42.07 -93.77,-93.78 0,-51.71 42.07,-93.775 93.77,-93.775 51.71,0 93.78,42.065 93.78,93.775 0,51.71 -42.07,93.78 -93.78,93.78"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path146"
        d="m 5314.67,2672.52 c 0,-25.89 -20.99,-46.89 -46.89,-46.89 -25.89,0 -46.89,21 -46.89,46.89 0,25.9 21,46.89 46.89,46.89 25.9,0 46.89,-20.99 46.89,-46.89"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path147"
        d="m 5430.33,2578.74 c 0,-10.36 -8.39,-18.75 -18.75,-18.75 -10.36,0 -18.76,8.39 -18.76,18.75 0,10.36 8.4,18.76 18.76,18.76 10.36,0 18.75,-8.4 18.75,-18.76"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path148"
        d="m 5167.75,2333.36 c 0,-16.41 -13.3,-29.7 -29.7,-29.7 -16.4,0 -29.69,13.29 -29.69,29.7 0,16.39 13.29,29.69 29.69,29.69 16.4,0 29.7,-13.3 29.7,-29.69"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path149"
        d="m 4977.07,3931.84 c 0,-27.62 -22.39,-50.01 -50.02,-50.01 -27.62,0 -50.01,22.39 -50.01,50.01 0,27.62 22.39,50.02 50.01,50.02 27.63,0 50.02,-22.4 50.02,-50.02"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path150"
        d="m 4780.13,3863.07 c 0,-13.81 -11.2,-25.01 -25,-25.01 -13.82,0 -25.01,11.2 -25.01,25.01 0,13.81 11.19,25.01 25.01,25.01 13.8,0 25,-11.2 25,-25.01"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path151"
        d="m 536.891,833.336 c -29.192,7.789 -46.539,37.769 -38.746,66.961 7.789,29.191 37.769,46.539 66.96,38.746 29.188,-7.789 46.536,-37.77 38.747,-66.961 -7.793,-29.191 -37.77,-46.539 -66.961,-38.746"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path152"
        d="m 450.746,946.957 c -10.008,2.672 -15.957,12.949 -13.285,22.957 2.672,10.008 12.949,15.957 22.957,13.285 10.008,-2.672 15.957,-12.949 13.285,-22.957 -2.672,-10.008 -12.949,-15.957 -22.957,-13.285"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path153"
        d="m 709.57,1119.69 c 18.004,67.45 87.524,107.68 154.969,89.68 67.445,-18.01 107.676,-87.53 89.672,-154.97 -18,-67.447 -87.52,-107.677 -154.969,-89.677 -67.445,18.004 -107.672,87.527 -89.672,154.967 z m 212.93,-56.83 c 13.332,49.96 -16.465,101.46 -66.426,114.79 -49.961,13.34 -101.457,-16.46 -114.789,-66.42 -13.336,-49.96 16.465,-101.46 66.422,-114.792 49.961,-13.336 101.457,16.462 114.793,66.422"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path154"
        d="m 800.766,2469.33 c 0,-39.7 -32.188,-71.89 -71.895,-71.89 -39.711,0 -71.898,32.19 -71.898,71.89 0,39.71 32.187,71.9 71.898,71.9 39.707,0 71.895,-32.19 71.895,-71.9"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path155"
        d="m 2678.57,3947.02 c 0,-26.75 -21.69,-48.45 -48.45,-48.45 -26.76,0 -48.45,21.7 -48.45,48.45 0,26.77 21.69,48.46 48.45,48.46 26.76,0 48.45,-21.69 48.45,-48.46"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path156"
        d="m 2775.48,3804.79 c 0,-10.36 -8.4,-18.75 -18.76,-18.75 -10.36,0 -18.76,8.39 -18.76,18.75 0,10.36 8.4,18.76 18.76,18.76 10.36,0 18.76,-8.4 18.76,-18.76"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path157"
        d="m 4509.5,3205.72 c 0,-23.3 -18.89,-42.2 -42.2,-42.2 -23.31,0 -42.2,18.9 -42.2,42.2 0,23.31 18.89,42.21 42.2,42.21 23.31,0 42.2,-18.9 42.2,-42.21"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path158"
        d="m 4409.47,3293.25 c 0,-16.4 -13.3,-29.7 -29.7,-29.7 -16.4,0 -29.7,13.3 -29.7,29.7 0,16.4 13.3,29.7 29.7,29.7 16.4,0 29.7,-13.3 29.7,-29.7"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path159"
        d="m 978.004,3332.17 c -21.16,9.77 -30.395,34.85 -20.625,56.01 9.769,21.16 34.844,30.39 56.001,20.62 21.16,-9.77 30.4,-34.85 20.63,-56.01 -9.78,-21.16 -34.85,-30.39 -56.006,-20.62"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path160"
        d="m 1099.4,3386.3 c -14.89,6.87 -21.39,24.52 -14.51,39.41 6.87,14.89 24.52,21.39 39.41,14.51 14.89,-6.88 21.39,-24.52 14.51,-39.41 -6.88,-14.89 -24.52,-21.39 -39.41,-14.51"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path161"
        d="m 3582.31,3938.8 c 13.41,50.22 65.17,80.18 115.4,66.78 50.23,-13.41 80.18,-65.18 66.78,-115.4 -13.4,-50.23 -65.17,-80.19 -115.4,-66.78 -50.23,13.4 -80.18,65.17 -66.78,115.4 z m 158.57,-42.32 c 9.92,37.2 -12.27,75.55 -49.47,85.48 -37.2,9.93 -75.55,-12.26 -85.48,-49.46 -9.93,-37.21 12.26,-75.55 49.46,-85.48 37.21,-9.93 75.56,12.25 85.49,49.46"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path162"
        d="m 3474.81,4034.33 c 0,-13.81 -11.19,-25.01 -25.01,-25.01 -13.8,0 -25,11.2 -25,25.01 0,13.81 11.2,25.01 25,25.01 13.82,0 25.01,-11.2 25.01,-25.01"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path163"
        d="m 289.672,3309.55 c -69.809,0 -126.602,56.79 -126.602,126.6 0,69.81 56.793,126.6 126.602,126.6 69.805,0 126.601,-56.79 126.601,-126.6 0,-69.81 -56.796,-126.6 -126.601,-126.6 z m 0,220.38 c -51.711,0 -93.781,-42.07 -93.781,-93.78 0,-51.71 42.07,-93.77 93.781,-93.77 51.707,0 93.777,42.06 93.777,93.77 0,51.71 -42.07,93.78 -93.777,93.78"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path164"
        d="m 2881.23,2902.62 c 0,0 55.89,-318.39 -351.6,-707.65 0,0 -1.24,-7.69 20.37,8.81 0,0 343.46,282.81 364.48,588.77 l -14.46,92.83 -18.79,17.24"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path165"
        d="m 2813.49,2978.83 c 0,0 -5.04,-443.28 -419.83,-789.8 0,0 -19.19,-4.79 8.44,19.68 0,0 353.25,341.78 383.7,842.99 l 27.69,-72.87"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path166"
        d="m 2720.92,3060.01 c 0,0 26.65,-411.52 -479.09,-910.66 0,0 -17.38,-6.66 6.99,20.44 0,0 420.91,420.25 440.56,913.2 l 31.54,-22.98"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path167"
        d="m 2590.23,3104.27 c 0,0 36.38,-361.01 -436.11,-950.75 0,0 -12.96,-5.27 2.48,15.39 0,0 395.99,503.71 406.68,928.14 l 26.95,7.22"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path168"
        d="m 2464.17,3040.46 c 0,0 -7.53,-372.33 -367.8,-830.78 l 8.44,19.68 c 0,0 311.72,434.73 343.02,801.11 l 16.34,9.99"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path169"
        d="m 2328.99,2939.71 c 0,0 18.71,-222.94 -205.61,-598.66 0,0 -0.56,9.56 6.64,21.55 0,0 174.93,346.87 174.53,546.33 l 24.44,30.78"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path170"
        d="m 2375.01,2376.73 c 2.17,-6.93 -2.32,-20.52 -9.24,-22.68 -6.93,-2.17 -14.58,1.6 -16.47,8.61 -1.23,4.59 6.14,3.21 8.62,16.46 1.33,7.13 14.92,4.53 17.09,-2.39"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path171"
        d="m 2606.3,2528.31 c 1.22,-3.89 -0.95,-8.04 -4.85,-9.26 -3.89,-1.22 -13.03,-2.34 -14.25,1.56 -1.22,3.89 5.94,11.32 9.84,12.54 3.89,1.23 8.04,-0.94 9.26,-4.84"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path172"
        d="m 2830.48,2795.97 c 1.29,-4.11 -0.82,-8.43 -4.72,-9.65 -3.89,-1.22 -11.5,6.51 -12.79,10.62 -1.29,4.11 7.71,8.44 11.6,9.65 3.9,1.22 4.63,-6.51 5.91,-10.62"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path173"
        d="m 2393.89,2912.62 c 1.35,-4.33 -3.1,-12.16 -7,-13.38 -3.89,-1.22 -8.15,1.3 -9.5,5.63 -1.36,4.33 0.7,8.82 4.59,10.04 3.9,1.22 10.55,2.04 11.91,-2.29"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path174"
        d="m 3592.3,3098.94 c 0,0 3.38,-148.48 -84.36,-344.2 l 37.12,40.5 c 0,0 107.98,188.97 47.24,303.7"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path175"
        d="m 3663.39,3109.06 c 0,0 16.88,-74.24 -10.12,-222.71 l 27,13.49 c 0,0 23.62,148.48 -16.88,209.22"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path176"
        d="m 4024.22,3152.88 c 0,0 16.87,-74.24 -10.12,-222.72 l 26.99,13.5 c 0,0 23.62,148.48 -16.87,209.22"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path177"
        d="m 4288.39,2743.98 c -9.85,9.22 -26.09,10.32 -37.01,2.63 -8.59,-6.05 -12.52,-15.11 -14.25,-24.84 -3.39,-6.13 -4.01,-13.27 -1.64,-19.97 -0.39,-2.25 -0.69,-4.5 -0.86,-6.68 -0.73,-9.03 13.34,-8.98 14.07,0 0.1,1.22 0.22,2.47 0.37,3.74 0.54,0.94 0.93,1.99 0.91,3.22 -0.02,0.65 -0.03,1.32 -0.04,2.01 1.86,8.43 6.1,15.43 16.75,11.68 6.92,-2.44 13.65,-5.37 20.9,-2 12.74,5.93 9.34,22.22 0.8,30.21"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path178"
        d="m 2149.86,3064.64 c -9.86,9.22 -26.1,10.32 -37.02,2.63 -8.59,-6.05 -12.52,-15.11 -14.25,-24.84 -3.39,-6.13 -4.01,-13.27 -1.64,-19.97 -0.39,-2.25 -0.68,-4.5 -0.86,-6.68 -0.73,-9.03 13.34,-8.98 14.07,0 0.1,1.22 0.23,2.47 0.38,3.74 0.54,0.94 0.92,1.99 0.9,3.22 -0.01,0.65 -0.02,1.32 -0.03,2.01 1.86,8.43 6.1,15.43 16.75,11.68 6.91,-2.44 13.64,-5.37 20.89,-2 12.74,5.93 9.34,22.22 0.81,30.21"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path179"
        d="m 4527.08,2621.02 c -9.86,9.22 -26.1,10.32 -37.02,2.63 -8.59,-6.05 -12.52,-15.11 -14.24,-24.85 -3.39,-6.12 -4.02,-13.26 -1.65,-19.96 -0.39,-2.25 -0.68,-4.5 -0.85,-6.68 -0.73,-9.02 13.34,-8.98 14.06,0 0.1,1.22 0.23,2.47 0.38,3.74 0.54,0.94 0.93,1.99 0.9,3.22 -0.01,0.65 -0.02,1.32 -0.03,2.01 1.86,8.43 6.1,15.43 16.75,11.68 6.92,-2.43 13.65,-5.37 20.89,-2 12.75,5.93 9.35,22.22 0.81,30.21"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path180"
        d="m 3372.22,1912.2 c -9.86,9.21 -26.09,10.31 -37.02,2.62 -8.58,-6.04 -12.52,-15.11 -14.24,-24.84 -3.39,-6.13 -4.01,-13.27 -1.64,-19.96 -0.39,-2.26 -0.68,-4.5 -0.86,-6.69 -0.73,-9.02 13.34,-8.97 14.06,0 0.11,1.22 0.23,2.47 0.39,3.74 0.53,0.95 0.92,2 0.9,3.22 -0.01,0.65 -0.02,1.32 -0.04,2.01 1.86,8.43 6.11,15.43 16.75,11.68 6.92,-2.43 13.65,-5.36 20.9,-2 12.74,5.93 9.34,22.23 0.8,30.22"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path183"
        d="m 1710.32,2075.22 c -9.86,9.22 -26.1,10.32 -37.02,2.63 -8.59,-6.05 -12.52,-15.11 -14.25,-24.85 -3.39,-6.12 -4.01,-13.26 -1.64,-19.96 -0.39,-2.25 -0.68,-4.5 -0.86,-6.68 -0.73,-9.02 13.34,-8.98 14.07,0 0.1,1.22 0.23,2.47 0.38,3.74 0.54,0.95 0.93,1.99 0.9,3.22 -0.01,0.65 -0.02,1.32 -0.03,2.01 1.86,8.43 6.1,15.43 16.75,11.68 6.92,-2.44 13.65,-5.37 20.89,-2 12.74,5.93 9.35,22.22 0.81,30.21"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path184"
        d="m 3178.84,2291.89 c -14.68,3.66 -24.09,-13.66 -21,-26.1 1.86,-7.47 11.91,-5.88 13.55,0.17 1.77,0.77 3.51,1.61 5.19,2.57 3.28,1.88 7.22,4.19 9.23,7.5 3.98,6.52 0.24,14.07 -6.97,15.86"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path185"
        d="m 3612.82,3379.24 c -14.68,3.65 -24.09,-13.66 -21,-26.1 1.85,-7.47 11.91,-5.88 13.54,0.17 1.78,0.77 3.52,1.61 5.19,2.57 3.29,1.87 7.23,4.19 9.24,7.5 3.98,6.52 0.23,14.07 -6.97,15.86"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path187"
        d="M 1659.23,478.934 C 1249.86,410.828 911.969,310.367 686.508,189.488 973.828,268.961 1357.27,332.539 1800.92,372.746 l -141.69,106.188"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path188"
        d="m 4130.28,484.426 c 425.59,-68.309 776.54,-171.293 1008.13,-295.895 -299.73,83.266 -704.82,149.168 -1174.12,189.16 l 165.99,106.735"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path189"
        d="m 1049.18,1861.97 c 0,0 3.43,-1284.736 1439.32,-1662.599 0,0 79,-6.871 -24.05,37.785 0,0 -1212.6,278.246 -1298.48,1518.324 0,0 -6.87,120.23 -116.79,106.49"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path190"
        d="m 4752.33,2030.97 c 0,0 -29.71,106.6 -127.57,104.86 0,0 -24.47,-1.75 6.99,-20.97 0,0 69.9,-8.74 40.19,-117.09 l 80.39,33.2"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path191"
        d="m 2899.93,2148.06 c 0,0 -26.22,-45.43 -92.63,-71.65 0,0 -36.69,-27.96 43.7,-15.73 0,0 82.13,29.71 117.08,15.73 0,0 55.92,-8.74 -10.48,38.45 0,0 -34.96,19.22 -38.45,43.69 0,0 -6.99,22.71 -19.22,-10.49"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path192"
        d="m 4411.3,1698.87 c 0,0 -306.4,-180.74 -1210.79,-214.95 21.55,-10.01 42.93,-20.43 64.12,-31.3 288.9,7.21 672.17,39.44 1054.32,139.16 0,0 131.58,41.51 92.35,107.09"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path193"
        d="m 4542.09,1637.54 c 0,0 -301.09,-177.63 -1187.34,-214.04 14.72,-8.47 29.39,-17.07 43.98,-25.86 3.31,-2 6.61,-4.01 9.92,-6.01 287.32,7.86 664.73,40.6 1041.09,138.81 0,0 131.57,41.52 92.35,107.1"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path194"
        d="m 4473.74,1524.29 c 0,0 -245.66,-144.9 -975.08,-167.48 12.74,-7.87 25.44,-15.82 38.12,-23.8 227.93,2.97 547.26,25.45 865.59,108.51 0,0 101.68,32.09 71.37,82.77"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path195"
        d="m 4456.83,1431.49 c 0,0 -208.6,-123.1 -837.65,-131.65 8.34,-5.54 16.72,-11.01 25.02,-16.62 175.83,-2.39 467.1,8.38 757.31,84.11 0,0 78.83,24.87 55.32,64.16"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path196"
        d="m 4443.41,1356.34 c 0,0 -178.63,-105.37 -721.56,-107.74 5.65,-4.11 11.35,-8.14 16.95,-12.31 135.56,-4.12 398,-0.53 659.47,67.7 0,0 64.31,20.29 45.14,52.35"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path197"
        d="m 4421.07,1280.85 c 0,0 -148.7,-87.56 -601.17,-88.36 3.8,-3.2 7.53,-6.48 11.3,-9.73 107.23,-3.92 330.5,-2.87 552.84,55.15 0,0 52.76,16.64 37.03,42.94"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path198"
        d="m 4349.75,1206.2 c 0,0 -111.46,-65.66 -450.23,-66.82 2.41,-2.43 4.69,-5.01 7.09,-7.46 82.18,-2.84 248.98,-1.55 415.14,41.8 0,0 39.9,12.59 28,32.48"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path199"
        d="m 3964.92,1078.28 c 1.81,-2.08 3.62,-4.17 5.42,-6.26 46.44,-2.57 152.38,-5.62 276.01,9.46 3.74,4.9 7.53,9.77 11.47,14.57 -71.66,-10.64 -167.53,-18.54 -292.9,-17.77"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path200"
        d="m 4023.8,1013.44 c 1.49,-2.21 2.99,-4.42 4.45,-6.65 34.06,-1.66 91.96,-3.1 162.53,0.68 2.38,3.93 4.77,7.84 7.15,11.75 -50.18,-3.76 -108.05,-5.97 -174.13,-5.78"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path201"
        d="m 2330.27,3311.3 c 0,0 288.93,59.85 536.58,-214.63 l 12.38,-51.6 c 0,0 -158.91,260.04 -497.36,257.97 0,0 -82.55,8.26 -51.6,8.26"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path202"
        d="m 2008.32,3092.54 c 0,0 -167.16,-115.57 82.56,-338.46 l 61.91,-2.06 c 0,0 -262.1,175.42 -154.79,309.56 0,0 30.96,43.34 10.32,30.96"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path203"
        d="m 4162.9,2976.97 c 0,0 200.19,82.55 274.48,-146.53 0,0 4.13,-20.64 -22.7,6.19 0,0 -61.91,173.36 -251.78,140.34"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path207"
        d="M 1822.36,360.121 C 1516.62,309.258 1264.27,234.23 1095.89,143.953 c 214.58,59.352 500.95,106.836 832.28,136.863 l -105.81,79.305"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path208"
        d="m 3947.79,364.227 c 317.85,-51.02 579.96,-127.93 752.91,-220.989 -223.85,62.184 -526.38,111.407 -876.87,141.27 l 123.96,79.719"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path209"
        d="m 4386.65,241.266 c 0,0 -556.63,-340.223 -1616.27,-212.6371 l 131.12,24.8047 c 0,0 598.93,14.1758 999.4,279.9724 l 485.75,-92.14"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
    </g>
    <g id="group1">
      <animateTransform
        attributeName="transform"
        attributeType="XML"
        type="translate"
        values="0,0; 0,-40; 0,0"
        dur="2s"
        begin="0.0s"
        repeatCount="indefinite"
      />
      <motion.path
        id="path135"
        d="m 5978.06,1866.27 c 291.51,-145.17 34.84,-364.67 34.84,-364.67 -228.79,-209.05 -488.94,-87.1 -488.94,-87.1 -65.03,42.96 -127.75,44.13 -127.75,44.13 -138.21,12.77 -275.25,167.24 -275.25,167.24 -186.98,190.46 -56.91,372.8 -56.91,372.8 170.73,226.47 343.77,147.5 343.77,147.5 62.72,-33.69 161.43,-49.94 161.43,-49.94 241.57,1.16 343.77,-162.6 343.77,-162.6 29.04,-47.61 65.04,-67.36 65.04,-67.36 z m -73.17,32.52 c 0,0 -99.87,180.01 -341.44,161.43 0,0 -69.68,-6.97 -155.63,42.98 0,0 -121.94,52.26 -256.66,-67.36 0,0 -174.21,-154.47 -5.81,-373.97 0,0 113.82,-161.43 281.06,-174.21 0,0 54.58,8.13 134.72,-44.13 0,0 197.43,-119.62 449.45,88.27 0,0 219.5,190.46 -62.71,327.5 0,0 -29.04,19.75 -42.98,39.49"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path136"
        d="m 5210.1,1659.26 c 0,0 60.1,-145.47 248.24,-116.72 0,0 28.75,13.06 50.52,6.97 0,0 86.24,36.58 167.24,-10.46 0,0 143.72,-111.49 315.32,31.36 0,0 13.06,12.2 -14.81,0 0,0 -145.46,-99.3 -287.44,9.58 0,0 -84.49,66.2 -155.92,21.78 0,0 -196.85,-103.66 -312.7,52.26 0,0 -20.91,35.71 -10.45,5.23"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path138"
        d="m 5528.03,1715.88 c 0,-10.59 -8.19,-19.17 -18.3,-19.17 -10.1,0 -18.29,8.58 -18.29,19.17 0,10.58 8.19,19.16 18.29,19.16 10.11,0 18.3,-8.58 18.3,-19.16"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path139"
        d="m 5341.63,1683.64 c 0,-5.28 -4.68,-9.58 -10.46,-9.58 -5.77,0 -10.45,4.3 -10.45,9.58 0,5.3 4.68,9.59 10.45,9.59 5.78,0 10.46,-4.29 10.46,-9.59"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
    </g>
    <g id="group2">
      <animateTransform
        attributeName="transform"
        attributeType="XML"
        type="translate"
        values="0,0; 0,-40; 0,0"
        dur="2s"
        begin="0.2s"
        repeatCount="indefinite"
      />
      <motion.path
        id="path122"
        d="m 966.402,1599.97 c -0.336,3.51 -0.726,7.01 -1.089,10.52 -19.422,-4.81 -36.692,-1.21 -36.692,-1.21 -15.098,3.48 -19.742,-6.97 -19.742,-6.97 -11.613,-68.52 -81.297,-73.17 -81.297,-73.17 -36.004,-1.16 -33.68,-16.25 -33.68,-16.25 -4.644,-32.52 -47.617,-37.17 -47.617,-37.17 -24.387,1.16 -24.387,-20.9 -24.387,-20.9 -16.261,-51.11 -69.683,-56.91 -69.683,-56.91 -30.195,-1.16 -40.649,-19.75 -40.649,-19.75 -209.05,-162.59 -455.261,120.79 -455.261,120.79 -87.1058,105.68 -39.489,144.01 -39.489,144.01 -77.8121,113.81 -32.5191,164.92 -32.5191,164.92 -25.5469,38.32 -11.6133,81.29 -11.6133,81.29 18.582,37.17 51.1014,27.88 51.1014,27.88 -11.613,46.45 19.742,77.81 19.742,77.81 38.328,34.84 77.813,2.32 77.813,2.32 -23.227,49.94 32.519,66.2 32.519,66.2 89.426,16.26 133.559,-42.97 133.559,-42.97 -1.16,32.52 37.164,27.87 37.164,27.87 104.523,-6.97 185.82,-130.07 185.82,-130.07 160.274,-200.92 301.961,-193.95 301.961,-193.95 14.325,-0.2 27.789,-0.57 40.528,-1.08 -0.887,11.16 -1.672,22.33 -2.325,33.51 -2.902,0.06 -4.523,0.08 -4.523,0.08 -174.207,6.97 -310.09,190.47 -310.09,190.47 -160.269,205.57 -263.633,126.59 -263.633,126.59 -162.593,80.14 -189.304,-34.84 -189.304,-34.84 -36.004,8.13 -65.039,-18.58 -65.039,-18.58 C 87.7813,1985.57 94.75,1937.95 94.75,1937.95 12.293,1926.34 42.4883,1803.23 42.4883,1803.23 8.80859,1737.03 68.0391,1648.77 68.0391,1648.77 9.96875,1546.57 202.758,1395.59 202.758,1395.59 c 242.73,-190.47 394.871,-65.04 394.871,-65.04 18.582,12.77 40.648,18.58 40.648,18.58 103.364,11.61 111.493,87.1 111.493,87.1 68.523,3.49 73.168,48.78 73.168,48.78 105.683,10.45 108.007,81.3 108.007,81.3 15.485,-1.15 28.055,0.47 38.227,3.55 -0.945,10.04 -1.813,20.08 -2.77,30.11"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path123"
        d="m 989.859,1445.53 c -58.679,4.58 -116.402,20.32 -116.402,20.32 -18.293,5.22 -17.422,-0.87 -17.422,-0.87 47.906,-22.65 102.785,-30.49 102.785,-30.49 -77.523,-71.42 -225.597,-1.74 -225.597,-1.74 l -4.36,-14.81 c 136.754,-76.65 229.086,-19.16 229.086,-19.16 15.676,6.97 32.227,5.22 32.227,5.22 5.847,0 11.494,0.11 16.964,0.3 -6.83,13.27 -12.644,27.1 -17.281,41.23"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path124"
        d="m 78.1992,1704.51 c 0,0 147.2068,-259.56 528.7228,-279.6 0,0 20.902,-2.61 -5.227,-6.1 0,0 -281.347,-10.45 -503.4606,187.28 l -26.1328,74.91 6.0976,23.51"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path125"
        d="m 66.0078,1843.01 c 0,0 133.2652,-266.54 626.2732,-363.22 0,0 2.614,-4.36 -13.937,-2.62 0,0 -408.516,49.65 -607.9846,318.8 l -4.3516,47.04"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path126"
        d="m 102.59,1923.14 c 0,0 202.953,-318.8 666.344,-382.38 0,0 15.675,3.48 -13.938,9.58 0,0 -432.906,70.55 -640.211,407.64 l -12.195,-34.84"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path127"
        d="m 212.34,2044.22 c 0,0 124.558,-315.32 619.308,-418.97 0,0 6.098,-3.48 -13.066,-1.74 0,0 -418.969,46.16 -628.019,393.7 l 21.777,27.01"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path128"
        d="m 378.707,2049.44 c 0,0 170.723,-307.47 542.656,-381.51 0,0 -3.484,-1.74 -24.386,0.87 0,0 -365.836,65.33 -570.532,398.06 l 52.262,-17.42"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path129"
        d="m 372.609,1944.05 c 0,-7.7 -6.824,-13.94 -15.242,-13.94 -8.418,0 -8.855,6.53 -8.855,14.23 0,7.7 4.355,15.1 12.777,15.1 8.418,0 11.32,-7.69 11.32,-15.39"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path130"
        d="m 354.32,1792.49 c 0,-4.81 -3.707,-8.71 -8.277,-8.71 -4.57,0 -8.273,3.9 -8.273,8.71 0,4.81 1.527,10.74 6.097,10.74 4.571,0 10.453,-5.93 10.453,-10.74"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path131"
        d="m 811.613,1591.28 c 0,-4.81 -3.121,-8.71 -6.968,-8.71 -3.848,0 -4.934,2.73 -4.934,7.55 0,4.81 1.086,9.87 4.934,9.87 3.847,0 6.968,-3.9 6.968,-8.71"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path132"
        d="m 451.004,1382.23 c 0,-4.33 -3.117,-7.84 -6.969,-7.84 -3.847,0 -6.969,3.51 -6.969,7.84 0,4.33 -0.652,10.45 3.196,10.45 3.847,0 10.742,-6.12 10.742,-10.45"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path133"
        d="m 393.516,1921.4 c 0,-2.4 -0.207,-6.68 -2.614,-6.68 -2.402,0 -6.097,4.28 -6.097,6.68 0,2.4 1.949,4.36 4.355,4.36 2.406,0 4.356,-1.96 4.356,-4.36"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path134"
        d="m 210.598,1730.64 c 0,-3.36 -2.149,-9.87 -5.516,-9.87 -3.367,0 -6.68,6.51 -6.68,9.87 0,3.37 2.731,6.1 6.098,6.1 3.367,0 6.098,-2.73 6.098,-6.1"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
    </g>
    <g id="group3">
      <animateTransform
        attributeName="transform"
        attributeType="XML"
        type="translate"
        values="0,0; 0,-40; 0,0"
        dur="2s"
        begin="0.4s"
        repeatCount="indefinite"
      />
      <motion.path
        id="path186"
        d="m 656.961,2981.43 c -14.68,3.66 -24.094,-13.66 -21,-26.1 1.852,-7.47 11.91,-5.88 13.543,0.17 1.777,0.77 3.519,1.61 5.191,2.57 3.285,1.88 7.227,4.2 9.239,7.5 3.976,6.52 0.234,14.07 -6.973,15.86"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path121"
        d="m 368.93,2818.45 c 6.015,-10.54 1.133,-24.65 -10.903,-31.52 -12.035,-6.88 -26.668,-3.91 -32.683,6.62 -6.016,10.53 -1.133,24.64 10.902,31.52 12.035,6.87 26.668,3.91 32.684,-6.62"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path120"
        d="m 400.836,3130.5 c 2.578,-4.52 1.312,-10.09 -2.824,-12.45 -4.137,-2.37 -9.578,-0.62 -12.157,3.89 -2.578,4.52 -1.316,10.09 2.825,12.45 4.136,2.36 9.578,0.62 12.156,-3.89"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path119"
        d="m 304.832,2700.85 c 4.082,-7.14 0.988,-16.59 -6.91,-21.1 -7.899,-4.52 -17.609,-2.38 -21.692,4.77 -4.082,7.14 -0.988,16.59 6.911,21.11 7.898,4.51 17.613,2.37 21.691,-4.78"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path118"
        d="m 237.746,2548.44 c 0,0 61.727,-57.48 235.559,102.02 0,0 21.015,26.46 106.883,57.44 0,0 139.308,38.62 196.152,204.75 0,0 52.301,146.68 -36.129,271.99 0,0 -14.137,9.99 -3.766,-8.17 0,0 105.543,-155.27 0.2,-291.31 0,0 -65.641,-66.39 -96.524,-117.74 0,0 -34.508,-45 -170.183,-89.98 0,0 -47.473,-13.87 -118.825,-87.14 0,0 -44.629,-48.36 -113.367,-41.86"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path117"
        d="m 740.223,3252.09 c 80.023,-15.71 122.41,-138.42 122.41,-138.42 C 972.816,2815.34 687.965,2689.98 687.965,2689.98 563.57,2627.36 462,2550.08 462,2550.08 219.156,2342.73 134.105,2508.51 134.105,2508.51 118.293,2548.85 95.2031,2542.89 95.2031,2542.89 19.5898,2546.67 5.86719,2667.68 5.86719,2667.68 -42.5664,3035 224.785,3205.76 224.785,3205.76 c 146.192,100.36 272.379,45.99 272.379,45.99 88.316,-38.67 155.379,-14.82 155.379,-14.82 51.887,27.23 87.68,15.16 87.68,15.16 z m -73.809,-37.34 c 0,0 -86.387,-30.07 -184.043,8.08 0,0 -153.293,61.77 -310.781,-105.25 0,0 -214.8322,-222.65 -123.7111,-506.59 0,0 12.1836,-33.98 48.7578,-34.77 0,0 25.4223,6.09 46.8123,-41.9 0,0 63.27,-119.21 273.156,31.98 0,0 100.02,80 189.907,114.49 0,0 335.824,135.2 204.89,453 0,0 -56.777,145.79 -144.988,80.96"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
    </g>
    <g id="group4">
      <animateTransform
        attributeName="transform"
        attributeType="XML"
        type="translate"
        values="0,0; 0,-40; 0,0"
        dur="2s"
        begin="0.6000000000000001s"
        repeatCount="indefinite"
      />
      <motion.path
        id="path206"
        d="m 4414.88,4243.48 c 0,0 -176.33,279.38 -512.96,210.68 0,0 -155.72,43.51 -254.19,-54.96 0,0 -25.19,25.19 11.45,59.54 0,0 84.73,77.86 231.29,38.93 0,0 320.6,80.15 524.41,-254.19"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path182"
        d="m 4258.72,4119.73 c -9.86,9.22 -26.09,10.31 -37.02,2.63 -8.58,-6.05 -12.52,-15.11 -14.24,-24.85 -3.39,-6.12 -4.02,-13.26 -1.65,-19.96 -0.38,-2.25 -0.67,-4.5 -0.85,-6.68 -0.73,-9.03 13.34,-8.98 14.06,0 0.1,1.21 0.23,2.47 0.38,3.74 0.54,0.94 0.93,1.99 0.9,3.22 -0.01,0.65 -0.02,1.32 -0.03,2.01 1.86,8.43 6.1,15.43 16.75,11.68 6.92,-2.44 13.65,-5.37 20.89,-2 12.75,5.93 9.35,22.22 0.81,30.21"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path116"
        d="m 4233.77,3636.38 c 0,-4.81 -3.51,-8.72 -7.84,-8.72 -4.33,0 -7.84,3.91 -7.84,8.72 0,4.81 3.51,8.71 7.84,8.71 4.33,0 7.84,-3.9 7.84,-8.71"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path115"
        d="m 3955.04,4246.97 c 0,-6.25 -5.07,-11.32 -11.33,-11.32 -6.25,0 -11.32,5.07 -11.32,11.32 0,6.26 5.07,11.33 11.32,11.33 6.26,0 11.33,-5.07 11.33,-11.33"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path114"
        d="m 4092.66,3839.33 c 0,-6.26 -4.29,-11.33 -9.58,-11.33 -5.29,0 -9.58,5.07 -9.58,11.33 0,6.25 4.29,11.32 9.58,11.32 5.29,0 9.58,-5.07 9.58,-11.32"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path113"
        d="m 4371.39,3858.49 c 0,-4.33 -3.51,-7.84 -7.84,-7.84 -4.32,0 -7.84,3.51 -7.84,7.84 0,4.33 3.52,7.84 7.84,7.84 4.33,0 7.84,-3.51 7.84,-7.84"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path112"
        d="m 4197.19,4209.52 c 0,-6.73 -4.68,-12.2 -10.46,-12.2 -5.77,0 -10.45,5.47 -10.45,12.2 0,6.73 4.68,12.19 10.45,12.19 5.78,0 10.46,-5.46 10.46,-12.19"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path111"
        d="m 4005.56,4351.21 c 0,0 225.31,-9.3 351.9,-256.67 0,0 10.45,-48.78 38.32,-80.13 0,0 101.04,-157.95 9.29,-269.45 0,0 -41.8,-32.51 -49.94,-85.94 0,0 -13.93,-181.17 -204.4,-181.17 0,0 0,3.48 15.1,9.29 0,0 175.37,5.81 176.53,206.72 0,0 -2.32,56.91 41.81,96.4 0,0 82.46,83.62 -4.65,219.5 0,0 -42.97,51.1 -51.1,89.43 0,0 -81.29,198.6 -301.96,243.89 0,0 -45.29,3.48 -20.9,8.13"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path110"
        d="m 4438.75,3670.64 c -54.58,-276.41 -285.7,-271.76 -285.7,-271.76 -218.34,-3.49 -206.72,298.47 -206.72,298.47 4.64,282.21 -180.02,387.9 -180.02,387.9 -202.08,117.3 -69.68,253.18 -69.68,253.18 81.3,89.43 206.73,56.91 206.73,56.91 284.53,83.62 508.68,-240.41 508.68,-240.41 216.02,-313.57 26.71,-484.29 26.71,-484.29 z m -34.84,413.45 c 0,0 -205.56,355.38 -491.26,282.21 0,0 -110.33,23.23 -169.56,-33.67 0,0 -119.63,-87.11 3.48,-188.15 0,0 220.66,-131.23 232.28,-375.12 0,0 -11.62,-337.97 192.79,-325.19 0,0 185.82,3.48 231.11,248.53 0,0 153.3,114.98 1.16,391.39"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
    </g>
    <g id="group5">
      <animateTransform
        attributeName="transform"
        attributeType="XML"
        type="translate"
        values="0,0; 0,-40; 0,0"
        dur="2s"
        begin="0.8s"
        repeatCount="indefinite"
      />
      <motion.path
        id="path109"
        d="m 5243.32,3772.3 c 0,-4.53 -6.6,-10.67 -10.68,-10.67 -4.08,0 -7.39,3.68 -7.39,8.21 0,4.54 3.31,8.21 7.39,8.21 4.08,0 10.68,-1.21 10.68,-5.75"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path108"
        d="m 5625.1,3530.51 c 0,-4.31 -3.31,-7.8 -7.39,-7.8 -4.08,0 -9.03,9.65 -9.03,13.96 0,4.31 9.87,5.75 13.95,5.75 4.08,0 2.47,-7.6 2.47,-11.91"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path107"
        d="m 5331.16,3342.09 c 0,-4.09 -3.3,-7.39 -7.38,-7.39 -4.08,0 -13.14,1.66 -13.14,5.74 0,4.08 9.06,9.03 13.14,9.03 4.08,0 7.38,-3.31 7.38,-7.38"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path106"
        d="m 5065.15,3266.55 c 0,-7.26 -8.35,-18.89 -15.6,-18.89 -7.25,0 -13.43,5.89 -13.14,13.14 0.2,4.76 6.82,1.24 13.14,13.14 3.41,6.4 15.6,-0.14 15.6,-7.39"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path105"
        d="m 5189.48,3817.55 c 0,0 -48.78,-218.34 -375.12,-509.85 0,0 2.32,9.3 12.77,18.59 0,0 270.6,278.73 329.83,469.19 l 32.52,22.07"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path104"
        d="m 5348.59,3873.3 c 0,0 -118.46,-353.07 -599.27,-682.89 l 13.94,16.25 c 0,0 427.38,321.71 566.75,661.99 l 18.58,4.65"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path103"
        d="m 5487.96,3896.52 c 0,0 -73.17,-355.38 -700.32,-776.96 0,0 -13.93,-1.16 6.97,13.94 0,0 528.43,362.35 665.48,764.18 l 27.87,-1.16"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path102"
        d="m 5599.45,3815.23 c 0,0 -97.56,-400.68 -729.35,-725.87 0,0 -18.58,-1.16 12.78,17.43 0,0 527.27,275.24 693.34,739.8 l 23.23,-31.36"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path101"
        d="m 5662.17,3692.12 c 0,0 -154.47,-440.16 -653.86,-646.89 0,0 -19.74,1.16 13.94,16.26 0,0 456.42,239.24 635.27,708.44 l 4.65,-77.81"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path100"
        d="m 5695.85,3620.12 c 0,0 -41.81,-320.55 -547.01,-570.24 0,0 -3.49,-6.97 22.06,2.32 0,0 412.29,167.24 523.78,452.94 l 13.94,92.91 -12.77,22.07"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path99"
        d="m 5159.29,3814.07 c 72,106.84 171.88,81.29 171.88,81.29 77.81,67.36 141.69,25.55 141.69,25.55 121.94,44.14 124.27,-81.29 124.27,-81.29 30.19,12.77 51.1,-6.97 51.1,-6.97 48.78,-46.46 30.2,-119.63 30.2,-119.63 72,-26.71 52.26,-135.88 52.26,-135.88 -6.97,-31.35 -2.33,-77.81 -2.33,-77.81 12.78,-195.11 -200.91,-349.58 -200.91,-349.58 -15.1,-108 -190.47,-181.17 -190.47,-181.17 -159.11,-67.36 -258.99,-30.2 -258.99,-30.2 -139.36,-53.42 -154.46,16.26 -154.46,16.26 -150.98,-30.19 -170.73,54.59 -170.73,54.59 -101.04,10.45 -85.94,77.81 -85.94,77.81 2.32,31.36 -9.29,46.46 -9.29,46.46 -37.16,36 19.75,87.1 19.75,87.1 -44.14,75.49 65.03,139.36 65.03,139.36 168.4,146.34 277.57,365.84 277.57,365.84 70.85,131.24 139.37,88.27 139.37,88.27 z m 308.92,63.87 c 0,0 -48.77,48.78 -137.04,-31.35 0,0 -68.52,55.74 -164.92,-73.17 0,0 -52.26,44.13 -112.65,-53.42 0,0 -146.33,-275.25 -318.22,-405.33 0,0 -62.71,-48.78 -13.93,-89.42 0,0 -58.07,-36.01 -30.2,-69.69 0,0 17.42,-16.26 10.45,-49.93 0,0 -13.93,-54.59 76.66,-61.56 0,0 18.58,-65.04 134.71,-41.81 0,0 34.85,8.13 53.43,-13.94 0,0 27.87,-26.71 88.26,-5.8 0,0 32.52,11.61 47.62,1.16 0,0 98.72,-23.23 261.31,54.58 0,0 118.46,58.07 124.27,137.04 0,0 214.85,166.08 191.63,353.07 0,0 34.84,116.13 -27.88,148.65 0,0 10.46,83.62 -29.03,116.14 0,0 -23.23,19.75 -48.78,3.48 0,0 11.62,70.85 -49.94,88.27 0,0 -29.03,9.29 -55.75,-6.97"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
    </g>
    <g id="group6">
      <animateTransform
        attributeName="transform"
        attributeType="XML"
        type="translate"
        values="0,0; 0,-40; 0,0"
        dur="2s"
        begin="1.0s"
        repeatCount="indefinite"
      />
      <motion.path
        id="path205"
        d="m 934.07,4390.04 c 0,0 -460.293,32.06 -519.832,-368.69 0,0 -98.468,-139.69 6.871,-306.87 0,0 2.289,-22.89 -27.48,4.59 0,0 -123.66,123.66 -36.641,302.28 0,0 68.7,414.49 577.082,368.69"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path181"
        d="m 1001.49,3721.92 c -9.857,9.22 -26.095,10.31 -37.017,2.63 -8.586,-6.05 -12.52,-15.11 -14.246,-24.85 -3.387,-6.12 -4.012,-13.27 -1.641,-19.96 -0.391,-2.25 -0.68,-4.5 -0.856,-6.69 -0.734,-9.01 13.336,-8.97 14.067,0 0.098,1.22 0.223,2.48 0.379,3.74 0.535,0.95 0.922,2 0.902,3.23 -0.012,0.64 -0.023,1.32 -0.035,2 1.855,8.44 6.102,15.43 16.75,11.69 6.918,-2.44 13.645,-5.37 20.897,-2 12.74,5.92 9.34,22.22 0.8,30.21"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path98"
        d="m 642.141,4036.6 c 2.894,4.24 2.668,9.43 -0.508,11.6 -3.176,2.18 -8.102,0.5 -10.996,-3.73 -2.899,-4.24 -2.672,-9.43 0.504,-11.61 3.179,-2.17 8.101,-0.5 11,3.74"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path97"
        d="m 1424.8,3810.79 c 2.18,3.18 0.72,7.96 -3.25,10.67 -3.97,2.72 -8.95,2.34 -11.12,-0.83 -2.18,-3.18 -0.72,-7.95 3.25,-10.67 3.97,-2.72 8.95,-2.34 11.12,0.83"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path96"
        d="m 1081.63,4072.27 c 3.62,5.29 0.55,13.69 -6.86,18.77 -7.41,5.06 -16.36,4.88 -19.98,-0.41 -3.62,-5.29 -0.55,-13.7 6.86,-18.77 7.42,-5.07 16.36,-4.89 19.98,0.41"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path95"
        d="m 669.16,3790.17 c 3.258,4.76 0.75,12.15 -5.601,16.49 -6.356,4.35 -14.149,4.01 -17.407,-0.76 -3.257,-4.76 -0.75,-12.15 5.602,-16.49 6.351,-4.35 14.144,-4.01 17.406,0.76"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path94"
        d="m 684.344,4199.09 c 0,0 247.679,131.7 440.256,-8.46 0,0 11.81,-36.23 40.97,-49.14 0,0 32.34,-16.49 34.66,-91.25 0,0 25.56,-207.44 123.43,-292.68 0,0 2.48,-8.73 -15.08,4.69 0,0 -95.81,69.75 -133.57,279.91 0,0 11.34,113.26 -126.49,144.22 0,0 -88.989,20.07 -96.102,44.63 0,0 -114.875,37.77 -256.52,-35.6 0,0 -27.293,-19.32 -11.554,3.68"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path93"
        d="m 1559.13,3566.95 c 0,0 215.78,212.61 -283.98,444.71 l -14.53,50.74 c 0,0 507.88,-226.39 322.47,-485.11 0,0 -29.66,-28.96 -23.96,-10.34"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path92"
        d="m 1521.79,3596.71 c 0,0 -48.39,75.31 -155.34,155.5 0,0 -94.55,67.49 -136.66,345.35 0,0 -6.58,150.84 -283.435,192.47 0,0 -427.746,30.88 -454.132,-345.06 0,0 -97.297,-136.07 124.738,-264.03 0,0 89.66,-152.79 430.569,-37.02 0,0 173.08,61.72 364.94,-56.86 0,0 67,-54.27 109.43,-35.45 0,0 20.93,-0.25 -4.09,-18.32 0,0 -50.69,-37.08 -130.2,21.53 0,0 -148.18,108.39 -330.44,59.99 0,0 -316.135,-145.38 -475.522,49.48 0,0 -217.644,117.92 -136.699,314.42 0,0 27.012,239.02 280.242,323.3 0,0 477.569,148.93 549.599,-212.72 0,0 35.04,-249.1 105.42,-316.95 0,0 100.2,-79.79 142.49,-153.74 0,0 19.87,-34.71 -0.91,-21.89"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
    </g>
    <g id="group7">
      <animateTransform
        attributeName="transform"
        attributeType="XML"
        type="translate"
        values="0,0; 0,-40; 0,0"
        dur="2s"
        begin="1.2000000000000002s"
        repeatCount="indefinite"
      />
      <motion.path
        id="path204"
        d="m 3343.16,4463.32 c 0,0 -109.92,-288.54 -389.3,-265.64 0,0 -70.99,20.61 -112.22,-43.51 0,0 -18.32,-16.03 16.04,-2.29 0,0 27.48,32.06 130.53,11.45 0,0 258.77,-38.93 354.95,299.99"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path13"
        d="m 3118.02,4775.34 c 1.58,-3 6.54,-7.8 9.55,-6.23 3,1.57 2.91,8.93 1.34,11.94 -1.57,3 -5.29,4.16 -8.3,2.59 -3,-1.57 -4.16,-5.29 -2.59,-8.3"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path12"
        d="m 2865.46,4860.11 c 1.13,-2.15 3.31,-5.86 5.46,-4.74 2.14,1.13 3.44,6.67 2.32,8.82 -1.13,2.15 -3.78,2.97 -5.93,1.85 -2.15,-1.13 -2.97,-3.78 -1.85,-5.93"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path11"
        d="m 3066.34,4351.78 c 2.02,-3.87 6.45,-5.54 9.88,-3.74 3.44,1.8 4.58,6.39 2.56,10.26 -2.03,3.87 -4.31,9.64 -7.74,7.84 -3.44,-1.8 -6.73,-10.49 -4.7,-14.36"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path10"
        d="m 2646.55,4369.77 c 2.25,-4.3 6.86,-6.32 10.3,-4.52 3.44,1.8 3.12,4.75 0.87,9.05 -2.25,4.29 -5.58,8.3 -9.02,6.5 -3.44,-1.8 -4.4,-6.74 -2.15,-11.03"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path9"
        d="m 2960.76,4763.34 c 2.25,-4.3 7.38,-6.05 11.46,-3.91 4.08,2.14 5.57,7.36 3.32,11.65 -2.25,4.3 -6.39,8.88 -10.47,6.74 -4.08,-2.14 -6.56,-10.19 -4.31,-14.48"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path8"
        d="m 2873.53,4890.11 c 3.6,-6.87 12.61,-9.25 20.13,-5.31 7.52,3.94 4.86,9.97 1.25,16.84 -3.6,6.88 -10.95,11.45 -18.46,7.51 -7.52,-3.94 -6.52,-12.16 -2.92,-19.04"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path7"
        d="m 2818.79,4981.37 c 0,0 -8.62,-354.41 -306.09,-594.5 0,0 3.92,0.08 21.37,12.18 0,0 296.1,229.47 323.23,622.33 l -38.51,-40.01"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path6"
        d="m 2969.79,5054.53 c 0,0 36.27,-339.82 -357.02,-663.8 0,0 -3.81,-5.97 12.48,4.55 0,0 352.52,237.2 376.61,645.32 l -32.07,13.93"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path5"
        d="m 3124.42,4997.75 c 0,0 -32.1,-379.59 -416.13,-653.13 0,0 -15.63,-4.23 7.97,15.08 0,0 353.54,265.49 380.97,663.46 l 27.19,-25.41"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path4"
        d="m 3194.57,4943.31 c 0,0 5.68,-300.33 -389.31,-617.28 0,0 -0.3,-5.11 13.67,4.18 0,0 341.55,235.43 393.75,569.07 l -18.11,44.03"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path3"
        d="m 3248.46,4813.95 c 0,0 -10.02,-300.64 -341.31,-496.99 0,0 -17.44,-12.11 7.52,-3 0,0 256.11,122.27 361.95,402.72 l -11.71,79.12 -16.45,18.15"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path2"
        d="m 2790.71,4264.88 c 0,0 -99.63,-131.49 -202.26,-103.97 0,0 45.33,32.67 77.51,75.3 0,0 -2.07,5.85 -15.96,-7.37 0,0 -139.33,-129.49 -204.59,-105.2 0,0 -30.41,8.85 -33.7,37.85 0,0 78.55,41.15 120.33,95.75 0,0 -4.41,4.63 -21.41,-10.22 0,0 -142.67,-119.34 -193.56,-86.53 0,0 -41.26,22 -31.41,82.67 0,0 -6.81,7.33 -10.92,-3.75 0,0 -35.85,-118.89 98.04,-117.14 0,0 39.37,-88.41 201.93,-3.25 0,0 13.96,9.3 31.22,10.41 0,0 109.34,-8.15 195.59,124.27 l -10.81,11.18"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
      <motion.path
        id="path1"
        d="m 2297.06,4270.6 c 0,0 -28.15,48.69 197.33,170.78 0,0 129.77,60.05 178.9,314.43 0,0 15.01,147.95 105.08,203.07 0,0 32.05,22.07 46.22,-7.51 0,0 11.7,73.54 99.16,100.84 0,0 57.38,11.56 60,-43.89 0,0 20.05,47.5 70.57,34.32 0,0 42.66,-13.33 54.03,-60.25 0,0 24.69,23.51 58.66,-0.98 0,0 32.55,-31.85 27.66,-78.02 0,0 64.35,-24.44 48.11,-162.47 0,0 60.44,-11.95 32.1,-147.06 0,0 -87.29,-368.21 -350.01,-320.81 0,0 -18.03,11.7 -45.53,-1.39 0,0 -50.42,-19.8 -88.85,18.22 0,0 -10.32,19.71 -31.55,7.26 0,0 -40.55,-15.95 -59.9,10.91 0,0 -4.99,14.57 -37.68,-1.24 0,0 -64.4,-28.44 -106.82,27.31 0,0 -9.04,7.16 -20.89,-3.01 0,0 -39.7,-32.7 -80.44,-10.43 0,0 -14.23,4.45 -24.84,-15.65 0,0 -34.13,-50.92 -102.23,-49.59 0,0 -17.82,1.24 8.1,-12.94 0,0 76.4,-24.73 131.12,44.9 0,0 32.49,-29.24 86.32,4.25 0,0 35.21,-62.17 134.47,-22.07 0,0 25.33,-38.27 88.15,-9.33 0,0 42.57,-63.61 140.3,-25.62 0,0 22.42,5.13 44.99,2.42 0,0 194.52,-40.84 322.16,242.78 0,0 101.52,224.99 1.87,289.09 0,0 11.6,106.52 -49.44,149.88 0,0 -30.63,124.04 -109.69,95.84 0,0 -16.05,45.78 -59.31,62.77 0,0 -38.42,10.27 -66.77,-13.83 0,0 -77.63,90.17 -185.33,-57.44 0,0 -129.24,22.16 -176.19,-236.36 0,0 -35.5,-227.41 -187.79,-315.12 0,0 -150.32,-81.39 -175.11,-127.42 0,0 -22.91,-34.47 7.96,-60.59 0,0 11.16,-8.69 15.11,3.95"
        style={{
          fill: "white",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "white",
        }}
        transform="matrix(0.13333333,0,0,-0.13333333,0,678.77333)"
      />
    </g>
  </motion.svg>
)
export default LogoWhite;